import $ from 'jquery';

$('body').on('click', '.radio-tile-item', function () {
    const input = $(this).find('input');
    input.prop('checked', true);

    $(this).parents('.radio-tile').find('.radio-tile-item').each(function () {
        const toggle = $(this).attr('data-toggle');
        if (toggle) {
            $(toggle).addClass('hidden');
            $(toggle).find('input').each(function () {
                const required = $(this).attr('required');
                if (required === 'required') {
                    $(this).attr('required', false);
                    $(this).attr('data-required', 'required');
                }
            });
        }
    });

    const toggle = $(this).attr('data-toggle');
    if (toggle) {
        $(toggle).removeClass('hidden');
        $(toggle).find('input').each(function () {
            const required = $(this).attr('data-required');
            if (required === 'required') {
                $(this).attr('required', true);
            }
        });
    }
});
